import React from 'react'
import { CContainer, CRow, CCol, CCard, CCardBody, CButton } from '@coreui/react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    })
    
    // Log error to console in development
    if (process.env.NODE_ENV === 'development') {
      console.error('Error caught by boundary:', error, errorInfo)
    }
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <CContainer className="min-vh-100 d-flex align-items-center justify-content-center">
          <CRow className="justify-content-center">
            <CCol md={12}>
              <CCard>
                <CCardBody className="text-center p-5">
                  <h2 className="text-danger mb-4">Oops! Something went wrong</h2>
                  <p className="text-muted mb-4">
                    We're sorry, but something unexpected happened. Please try refreshing the page.
                  </p>
                  
                  {process.env.NODE_ENV === 'development' && this.state.error && (
                    <div className="text-start mb-4">
                      <h5>Error Details:</h5>
                      <pre className="bg-light p-3 rounded small">
                        {this.state.error.toString()}
                        {this.state.errorInfo.componentStack}
                      </pre>
                    </div>
                  )}
                  
                  <CButton 
                    color="primary" 
                    onClick={this.handleReload}
                    className="me-2"
                  >
                    Refresh Page
                  </CButton>
                  
                  <CButton 
                    color="secondary" 
                    variant="outline"
                    onClick={() => window.history.back()}
                  >
                    Go Back
                  </CButton>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </CContainer>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary